import { LanguagesAbbr, Session } from "../types/working-model";
import { getNavigatorLanguage } from "./utils";


// this function returns a default language code based on the event passed in
export function getDefaultLanguageCode(session: Session | undefined | null): string {

	if (session) {
		// if session has default language, return
		if (session.default_language)
			return session.default_language;

		// if navigator has a language return
		const lang = getNavigatorLanguage();
		if (lang) {
			return lang;
		}

		// if no default language, return first language listed for session
		if (session.languages.length)
			return session.languages[0];

		// if no languages listed in session, return english
		return 'en';
	}
	// default return english
	return 'en';
}



//Currently base language for homepage is locked to "en", Keeping this code in case we add dynamic homepage base language in later
//This mirrors the logic in the events-api repo: events.ts -> createEvent() 
export function getHomepageDefaultLanguage(/*sessions: Session[]*/): LanguagesAbbr {
	// Eventually this should become UI accesable so the user can choose homepages default language (this would require adding a default language column to homepage table)
	// for now we figure out the default language of home page based on sessions
	// if english exists as a default language in any session use that
	// if not use the default language of the first session

	// const baseLanguages = [];
	// for (const session of sessions) {
	// 	baseLanguages.push(session.default_language);
	// }

	// return baseLanguages.includes("en") ? "en" : baseLanguages[0];



	//Code for locking homepage/landing base to english
	return "en";
}